var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckedBox = function SvgCheckedBox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.433 5.825A4 4 0 0 0 21 5H9a4 4 0 0 0-4 4v12a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4v-8.257l-2 2V21a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h12c.362 0 .7.096.994.264z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M28.207 5.293a1 1 0 0 1 0 1.414l-12 12a1 1 0 0 1-1.414 0l-4.5-4.5a1 1 0 1 1 1.414-1.414l3.793 3.793L26.793 5.293a1 1 0 0 1 1.414 0",
    clipRule: "evenodd"
  })));
};
export { SvgCheckedBox as ReactComponent };
export default __webpack_public_path__ + "fonts/checked-box-a7885c87f458b79ca66240c883489063.svg";